import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, Button, message } from "antd";

const TaxesDrawer = ({ open, setOpen, data, isEdit, onSubmit }) => {
  const [form] = Form.useForm();
  const [isLoading, setLoading] = useState(false);

  const defaultData = {
    taxName: "",
    percentage: "",
  };

  useEffect(() => {
    if (open) {
      if (isEdit && data) {
        form.setFieldsValue(data);
      } else {
        form.resetFields();
      }
    }
  }, [open, isEdit, data, form]);

  const onFinish = async (values) => {
    // if (values.percentage < 1 || values.percentage > 100) {
    //   message.error("Percentage must be between 1 and 100.");
    //   return;
    // }
    setLoading(true);
    try {
      if (isEdit) {
        await onSubmit({ ...data, ...values });
      } else {
        await onSubmit(values);
      }
      form.resetFields();
      setOpen(false);
    } catch (err) {
      console.error(err);
      message.error(
        err.response.data.message ||
          "Failed to submit the form. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer
      title={isEdit ? "Edit Tax" : "Add Tax"}
      width={450}
      placement="right"
      onClose={() => setOpen(false)}
      open={open}
      destroyOnClose
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        initialValues={defaultData}
      >
        <Form.Item
          label="Tax Name"
          name="taxName"
          rules={[{ required: true, message: "Please enter the tax name." }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Percentage"
          name="percentage"
          rules={[{ required: true, message: "Please enter the percentage." }]}
        >
          <Input type="number" min={0} max={100} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" block htmlType="submit" loading={isLoading}>
            {isEdit ? "Update Tax" : "Add Tax"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default TaxesDrawer;
